module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/$.iterators.js
// module id = 35
// module chunks = 0